export default function docReady(fn: () => void) {
  // see if DOM is already available
  if (['complete', 'interactive'].includes(document.readyState)) {
    // call on next available tick
    fn();
  } else {
    document.addEventListener('DOMContentLoaded', fn);
  }
}
